import Button from '@hig/button';
import '@hig/button/build/index.css';
import { t, Trans } from '@lingui/macro';
import { I18n } from '@lingui/react';
import log from 'loglevel';
import PropTypes from 'prop-types';
import React from 'react';
import { totalMinutes, waitTimeTimeout } from '../../app.config';
import { getEstimatedWaitTime } from '../../utils/waitTimeHelpers';
import ErrorBoundary from '../ErrorBoundary';
import '../UserInfoForm/UserInfoForm.styles';
import * as Styles from '../UserInfoForm/UserInfoForm.styles.js';

class CallbackConfirm extends React.PureComponent {

  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      ...props.variables,
      closeModal: this.props.closeModal,
      waitTime: -1,
      waitTimeMsg: '',
      showUnavailable: false,
      showNoAgent: false,
      inactivePage: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const data = {
      contactId: this.props.variables.contactId,
      skillId: this.props.variables.skillId,
      requestId: this.props.variables.requestId,
    };
    getEstimatedWaitTime(data, this, false);
    this.interval = setInterval(() => getEstimatedWaitTime(data, this, false), waitTimeTimeout);
    setTimeout(() => { clearInterval(this.interval); }, totalMinutes);
  }

  componentWillUnmount() {
    this._isMounted = false;
    log.debug('Interval', this.interval);
    if (typeof this.interval !== 'undefined') {
      clearInterval(this.interval);
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <Styles.StyledWrapper>
          <Styles.StyledForm>
            <Styles.StyledH1>
              <Trans>You are all set!</Trans>
            </Styles.StyledH1>
            <Styles.StyledErrorNotice>
              <div id='unavailable' style={{ display: this.state.showUnavailable ? 'block' : 'none' }}>
                <I18n>
                  {({ i18n }) => (
                    i18n._(t`Service is unavailable at the moment. Please try again later.`)
                  )}
                </I18n>
              </div>
              <div id='no-agent' style={{ display: this.state.showNoAgent ? 'block' : 'none' }}>
                <I18n>
                  {({ i18n }) => (
                    i18n._(t`No agents are available at the moment. Please try again later.`)
                  )}
                </I18n>
              </div>
            </Styles.StyledErrorNotice>
            <Styles.StyledFlexRow>
              <Styles.StyledFlexColumn>
                <Styles.StyledStandardText
                  className={this.state.inactivePage ? 'inactive-page' : ''}
                  style={{ display: this.state.inactivePage ? 'none' : 'block' }}
                >
                  <div className='text-spinner' style={{ display: this.state.waitTime === -1 ? 'block' : 'none' }}></div>
                  <div style={{ display: this.state.waitTime === -1 ? 'none' : 'block' }}>
                    <Trans>
                      Estimated wait time: about {this.state.waitTime} minutes
                    </Trans>
                  </div>
                </Styles.StyledStandardText>
                <Styles.StyledLargeText className={this.state.inactivePage ? 'inactive-page' : ''}>
                  <Trans>Your details have been recorded. One of our agents will be in touch with you.</Trans>
                </Styles.StyledLargeText>
                <br />
                <Styles.StyledLargeText className={this.state.inactivePage ? 'inactive-page' : ''}>
                  <Trans>Thank you.</Trans>
                </Styles.StyledLargeText>
              </Styles.StyledFlexColumn>
            </Styles.StyledFlexRow>
          </Styles.StyledForm>
          <Styles.StyledLine color="#cccccc"></Styles.StyledLine>
          <Styles.StyledFormSubmission>
            <Styles.StyledFlexRow>
              <Styles.StyledFlexColumn>
                <Styles.StyledPrimaryCtaButton>
                  <I18n>
                    {({ i18n }) => (
                      <Button
                        size="large"
                        title={i18n._(t`CLOSE`)}
                        onClick={() => this.state.closeModal(true)}
                        data-wat-val="close modal after request"
                      />
                    )}
                  </I18n>
                </Styles.StyledPrimaryCtaButton>
              </Styles.StyledFlexColumn>
            </Styles.StyledFlexRow>
          </Styles.StyledFormSubmission>
        </Styles.StyledWrapper>
      </ErrorBoundary>
    );
  }
}

CallbackConfirm.propTypes = {
  variables: PropTypes.object,
  closeModal: PropTypes.func,
};

export default CallbackConfirm;
